import { CustomThemeConfigOptions } from "../utils/createThemeOptions";

export const PayshopOptions: CustomThemeConfigOptions = {
    name: "payshop",
    support_email: "onboarding.pop@payshop.pt",
    accent: "#DF0024",
    default_language: "pt",
    headName: "POP Backoffice",
};
